<template>
  <div>
    <custom-actions show-back title="信息确认">
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="160px"
        v-loading="loading">
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item prop="inventoryType" label="类型">
              <el-select v-model="formData.inventoryType" placeholder="请选择类型">
                <el-option v-for="([key, value], index) of inventoryTypeMap" :value="key" :label="value"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item v-if="formData.inventoryType === '1'" prop="ygId" label="油罐名称">
              <el-select v-model="formData.ygId" clearable @change="changeInfo" filterable placeholder="请选择油罐名称">
                <el-option v-for="(item, index) of guanList"
                  :value="item.ygId"
                  :disabled="(!parseFloat(item.ygWeight) || !item.userId) && ygType === '2' "
                  :label="`${item.ygCode} (${item.ygWeight}吨)`"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="formData.inventoryType === '2'" prop="ygId" label="成品油名称">
              <el-select v-model="formData.ygId" clearable @change="changeInfo" filterable placeholder="请选择油罐名称">
                <el-option v-for="(item, index) of cpyList"
                  :value="item.ygId"
                  :disabled="!parseInt(item.ygNumber) && ygType === '2'"
                  :label="`${item.userName}(${item.oilTypeName || '--'})/(数量:${item.ygNumber || 0})`"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="formData.inventoryType === '2'">
            <el-form-item prop="ygWeight" label="数量">
              <el-input-number v-model="formData.ygWeight" @change="computedYgLevel" :min="0" :max="9999"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="formData.inventoryType === '1'">
          <el-col :span="12">
            <el-form-item prop="ygLevel" label="本次变化液位">
              <el-input-number v-model="formData.ygLevel" @change="computedYgWeight" :min="0" :max="9999"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygWeight" label="本次变化重量">
              <el-input-number v-model="formData.ygWeight" @change="computedYgLevel" :min="0" :max="9999"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="userId" label="客户">
              <el-select disabled v-model="formData.userId" filterable placeholder="请选择类型">
                <el-option v-for="(item, index) of userList" :value="item.userId" :label="item.userName"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverName" label="司机姓名">
              <el-input v-model="formData.driverName" placeholder="请输入司机姓名"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="driverMobile" label="司机手机号">
              <el-input placeholder="请输入司机手机号" v-model="formData.driverMobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleKey" label="车牌号">
              <el-input placeholder="请输入车牌号" v-model="formData.vehicleKey"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="vehicleDate" label="进场日期">
              <el-date-picker v-model="formData.vehicleDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                placeholder="请选择进场日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="vehicleTime" label="进场时间">
              <el-select v-model="formData.vehicleTime" placeholder="请选择进场时间">
                <el-option value="1" label="上午"></el-option>
                <el-option value="2" label="下午"></el-option>
                <el-option value="3" label="夜晚"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="goodsCode" label="商品编号">
              <el-select v-model="formData.goodsCode" placeholder="请选择商品编号">
                <el-option v-for="(item, index) of goodsCodeList" :value="item.dicCode" :label="item.dicValue"
                  :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygRegion" label="收货地址">
              <el-cascader v-model="areaValue" :props="{ value: 'label', label: 'label' }" :options="areaData"
                @change="handleAreaChange"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="ygAddress" label="详情地址">
              <el-input v-model="formData.ygAddress" placeholder="请输入详细地址" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="shippingFee" :label="inventoryType === '1' ? '运费单价' : '运费总价'">
              <el-input-number v-model="formData.shippingFee" :placeholder="`请输入运费${inventoryType === '1' ? '单价' : '总价'}`" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item prop="isShippingFee" label="是否缴纳运费">
              <el-radio-group v-model="formData.isShippingFee">
                <el-radio label="1">是</el-radio>
                <el-radio label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ygNotes" label="状态">
              {{ ygFhStateMap.get(formData.ygFhState) }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item prop="ygNotes" label="备注">
              <el-input type="textarea" v-model="formData.ygNotes" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-col :span="24">
            <el-form-item label="附件" prop="fileList">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <template v-if="approve && !!formData.upNode">
          <el-divider content-position="left">审批</el-divider>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审批意见" prop="nodeOpinion">
                <el-input type="textarea" v-model="formData.nodeOpinion" placeholder="请输入审批意见" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="审批结果" prop="nodeResult">
                <el-radio-group v-model="formData.nodeResult">
                  <el-radio label="1">通过</el-radio>
                  <el-radio label="2">驳回</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </template>

        <template v-if="!ygType || approve">
          <el-divider content-position="left">审批记录</el-divider>
          <el-row>
            <el-col :span="24">
              <el-timeline>
                <el-timeline-item v-for="(item, index) of formData.recordList" :key="index" :timestamp="item.ctime" placement="top">
                  <el-card>
                    <h4>审批节点：{{ item.nodeName }}</h4>
                    <p>审批状态：{{ nodeResultMap.get(item.nodeResult) }}</p>
                    <p v-if="item.nodeOpinion">审批意见：{{ item.nodeOpinion }}</p>
                  </el-card>
                </el-timeline-item>
              </el-timeline>
            </el-col>
          </el-row>
        </template>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button type="primary" class="global-button" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { inventoryType, ygType, nodeResult, ygFhState } from '@/utils/dict'
import { validPhoneNumber } from '@/utils/validator.js'
export default {
  name: 'RecordManageAdd',
  data () {
    return {
      detail: {},
      areaValue: [],
      areaData: [],
      ygTypeMap: ygType,
      inventoryTypeMap: inventoryType,
      ygFhStateMap: ygFhState,
      nodeResultMap: nodeResult,
      dicList: [],
      formData: {
        ygId: '', // 油罐id/成品油记录id
        ygType: '',
        ygLevel: '', // 本次变化液位(改)
        ygWeight: '', // 本次变化重量(改)
        userId: '', // 客户id
        driverName: '', // 司机姓名
        driverMobile: '', // 司机手机号
        vehicleKey: '', // 车/船号牌
        vehicleType: '1', // 类型1车辆2船
        vehicleDate: '', // 车/船进厂日期
        vehicleTime: '', // 车/船进厂时间1上午2下午
        inventoryType: '1', // 类型1油罐2成品油
        fileList: [], // 附件列表
        goodsCode: '', // 商品编号 字典goodsCode
        ygRegion: '', // 收货地址-省市区
        ygAddress: '', // 收货地址-详细地址
        shippingFee: '', // 运费单价
        ygNotes: '', // 备注
        nodeOpinion: '', //
        nodeResult: '',
        recordList: [],
        upNode: '', // 上级节点，如果为空就不显示审批
        isShippingFee: '0'
      },
      rules: {
        ygId: [{ required: true, message: '请选择油罐名称', trigger: ['blur', 'change'] }],
        ygType: [{ required: true, message: '请选择收发油', trigger: ['blur', 'change'] }],
        ygLevel: [{ required: true, message: '请输入本次变化液位', trigger: ['blur', 'change'] }],
        ygWeight: [{ required: true, message: '请输入本次变化重量', trigger: ['blur', 'change'] }],
        userId: [{ required: true, message: '请选择客户', trigger: ['blur', 'change'] }],
        driverName: [{ required: true, message: '请输入司机姓名', trigger: ['blur', 'change'] }],
        driverMobile: [
          { required: true, message: '请输入司机手机号', trigger: ['blur', 'change'] },
          { pattern: validPhoneNumber, message: '手机号格式错误' }
        ],
        vehicleKey: [{ required: true, message: '请输入车牌号', trigger: ['blur', 'change'] }],
        vehicleDate: [{ required: true, message: '请选择进场日期', trigger: ['blur', 'change'] }],
        vehicleTime: [{ required: true, message: '请选择进场时间', trigger: ['blur', 'change'] }],
        inventoryType: [{ required: true, message: '请选择类型', trigger: ['blur', 'change'] }],
        goodsCode: [{ required: true, message: '请选择商品编号', trigger: ['blur', 'change'] }],
        ygRegion: [{ required: true, message: '请选择收货地址', trigger: ['blur', 'change'] }],
        ygAddress: [{ required: true, message: '请输入收获详细地址', trigger: ['blur', 'change'] }],
        shippingFee: [{ required: true, message: '请输入运费单价', trigger: ['blur', 'change'] }],
        nodeOpinion: [{ required: true, message: '请输入审批意见', trigger: ['blur'] }],
        nodeResult: [{ required: true, message: '请选择审批结果', trigger: ['blur'] }]
      },
      loading: false,
      guanList: [],
      cpyList: [],
      userList: [],
      goodsCodeList: [],
      ygInfo: {}
    }
  },
  created () {
    this.formData.ygType = this.ygType
    this.formData.inventoryType = this.inventoryType
    if (this.inventoryType === '1') {
      this.getGuan()
    } else if (this.inventoryType === '2') {
      this.loadCPYList()
    }
    if (this.inventoryId) {
      this.loadData()
    }
    this.loadArea()
    this.loadUserList()
    this.loadDict()
  },
  computed: {
    inventoryId () {
      return this.$route.query.inventoryId
    },
    approve () {
      return this.$route.query.approve === '1'
    },
    inventoryType () {
      return this.$route.query.inventoryType
    },
    ygType () {
      return this.$route.query.ygType
    },
    ygTypeName () {
      if (this.approve) {
        return this.ygTypeMap.get(this.ygType) + '审批'
      } else {
        return (this.inventoryId ? '编辑' : '新增') + this.inventoryTypeMap.get(this.inventoryType) + this.ygTypeMap.get(this.ygType)
      }
    }
  },
  methods: {
    changeInfo (id) {
      if (this.inventoryType === '1') {
        const data = this.guanList.find(item => item.ygId === id)
        console.log('data', data)
        this.ygInfo = data
        this.formData.userId = data.userId
      }
      if (this.inventoryType === '2') {
        const data = this.cpyList.find(item => item.ygId === id)
        this.formData.userId = data.userId
      }
    },
    computedYgWeight (ygLevel) {
      if (this.inventoryType === '2') {
        return
      }
      const info = this.ygInfo
      if (info.ygDiameter && info.ygDensity) {
        this.formData.ygWeight = parseFloat(Math.pow((info.ygDiameter / 2), 2) * Math.PI * ygLevel * info.ygDensity).toFixed(2)
      }
    },
    computedYgLevel (ygWeight) {
      if (this.inventoryType === '2') {
        return
      }
      const info = this.ygInfo
      if (info.ygDiameter && info.ygDensity) {
        this.formData.ygLevel = parseFloat(ygWeight / (Math.pow((info.ygDiameter / 2), 2) * Math.PI * info.ygDensity)).toFixed(2)
      }
    },
    handleAreaChange (value) {
      this.formData.ygRegion = value.join(' ')
    },
    loadUserList () {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2'
      }).then(res => {
        this.userList = res.list
      })
    },
    loadCPYList () {
      const params = {
        page: 1,
        size: 999
      }
      this.$axios.get(this.$apis.oiltabkManage.selectYgUserInventoryByList, {
        params: params
      }).then(res => {
        this.cpyList = res.list
      })
    },
    loadArea () {
      this.$axios.get(this.$apis.common.selectCity).then(res => {
        this.areaData = res
      })
    },
    areaChange (data) {
      this.form.provinceNum = data[0] // string  详见数据字典表tbxzqdmdic注册所在省(自治区、直辖市）
      this.form.cityNum = data[1] // string  详见数据字典表tbxzqdmdic注册所在地（市、州、盟）
      this.form.countyNum = data[2] // string  详见数据字典表tbxzqdmdic注册所在县（区、市、旗）
    },
    getGuan () {
      this.$axios.get(this.$apis.oiltabkManage.selectYgInfoByList).then(res => {
        this.guanList = res.list || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.recordManage.selectYgInventoryByYgId, {
        params: { inventoryId: this.inventoryId }
      }).then(res => {
        this.formData = res
        if (this.formData.ygRegion) {
          this.areaValue = this.formData.ygRegion.split(' ')
        }
        // 如果没有上级几点就默认通过，不需要审批了
        if (!this.formData.upNode) {
          this.formData.nodeResult = '1'
        }
        // if (this.inventoryId) {

        // }
      }).finally(() => {
        this.loading = false
      })
    },
    loadDict () {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'goodsCode' }
      }).then(res => {
        this.goodsCodeList = res.goodsCode
      })
    },
    submit () {
      this.$refs.form.validate().then(() => {
        this.loading = true

        let url = this.$apis.recordManage.insertYgInventory
        if (this.approve) {
          url = this.$apis.recordManage.approveYgInventory
        } else if (this.inventoryId) {
          url = this.$apis.recordManage.updateYgInventory
          this.formData.ygFhState = '3'
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.shoufa-form {
  width: 800px;
}

::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-date-editor {
    width: 100%;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
